export const footerProducts = [
  {
    id: 1,
    item: "Pointe Shoes",
    toName: "pointe-shoes",
    to: "collections",
  },
  {
    id: 2,
    item: "Adult Leotards",
    toName: "adult-leotards",
    to: "collections",
  },
  {
    id: 3,
    item: "Youth Leotards",
    toName: "youth-leotards",
    to: "collections",
  },

  {
    id: 4,
    item: "Soft Ballet Shoes",
    toName: "soft-ballet-shoes",
    to: "collections",
  },
  {
    id: 5,
    item: "Tutus",
    toName: "tutus",
    to: "collections",
  },
];

export const footerCollections = [
  {
    id: 1,
    item: "35 Years of Excellence",
    toName: "35-years-of-excellence",
    to: "collections",
  },
  {
    id: 2,
    item: "Classic Excellence",
    toName: "classic-excellence",
    to: "collections",
  },
  {
    id: 3,
    item: "Nikolay Academy",
    toName: "nikolay-academy",
    to: "collections",
  },
  {
    id: 4,
    item: "Radiance",
    toName: "radiance",
    to: "collections",
  },
];
